
<div>
    <Modal ref="modal-login" id="modal-login" v-if="showModal" @close="hide()">
        <div slot="body" class="d-block">
            <div class="container">
                <div class="row">
                    <div class="col-10">
                        <p class="modal-title mt-3 mb-3">
                            {{ (showLogin ? 'Inicia sesión' : 'Registro') }}
                        </p>
                        <p v-if="showLogin" class="modal-description-text">
                            Ingresa tu cuenta de correo electrónico con la que te registraste y te enviaremos un mail con tu acceso.
                        </p>
                        <p v-else class="modal-description-text">
                            Ingresa tu información para completar tu registro.
                        </p>
                    </div>
                    <div class="col-2 text-right">
                        <img v-img-prefix @click="hide()" class="img-close float-right mt-3 mb-3"
                             :src="`/public-assets/close-modal`" alt="close-modal">
                    </div>
                </div>
                <div class="row" v-if="showLogin">
                    <div class="col-12 mt-2 mb-2 text-center" v-if="showMeesageConfirm != null">
                        <label class="validation">
                            {{ showMeesageConfirm }}
                        </label>
                    </div>
                    <div class="col-12 col-md-12">
                        <input v-model="userCredentials.email" @blur="validateFormat('email', 'email')" type="email" class="form-control" placeholder="Correo Electrónico">
                        <label class="validation" v-show="errors['email']">{{errors['email']}}</label>
                    </div>
                    <div class="col-12 col-md-12 text-right">
                        <button v-if="!isLoading" @click="login()" class="btn-custom mt-4 w-30">Enviar Acceso</button><br>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center" v-if="isLoading && showLogin">
                        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                    <div class="border-top mt-4 mb-4 w-100"></div>
                <div class="row" v-if="!showLogin">
                    <div class="col-6">
                        <input v-model="userCredentials.firstName" type="text" class="form-control" placeholder="Nombre">
                        <label class="validation" v-show="errors['firstName']">{{errors['firstName']}}</label>
                    </div>
                    <div class="col-6">
                        <input v-model="userCredentials.lastName" type="text" class="form-control" placeholder="Apellido">
                        <label class="validation" v-show="errors['lastName']">{{errors['lastName']}}</label>
                    </div>
                    <div class="col-12 text-center">
                        <p class="login-chooice mt-4 mb-4">Ingresa tu correo electrónico y numero de teléfono</p>
                    </div>
                     <div class="col-6">
                        <input @click="methodLogin('mail')" :readonly="!isWithMail" v-model="userCredentials.email" @blur="validateFormat('email', 'email')" type="email" class="form-control" placeholder="Correo Electronico">
                        <label class="validation" v-show="errors['email']">{{errors['email']}}</label>
                    </div>
                    <div class="col-6">
                        <input type="phone" autocomplete="off" v-mask="'(###)-###-####'" @input="checkClientPhoneNumber()" v-model="userCredentials['phone']['number']" placeholder="Teléfono Celular" class="form-control" id="phone">
                        <label class="validation" v-show="errors['phone']">{{errors['phone']}}</label>
                    </div>
                    <div class="col-12">
                        <p class="terms-text mt-3">
                            <input v-model="terms" class="check-terms" type="checkbox" aria-label="Checkbox for following text input">
                            <span class="ml-3">Acepto </span><span class="conditions-text">terminos y condiciones</span>
                            <br v-show="errors['terms']">
                            <label class="validation" v-show="errors['terms']">{{errors['terms']}}</label>
                        </p>
                    </div>
                    <div class="col-12 mb-5">
                        <div class="row">
                            <div class="col-12 text-center" v-if="isLoading">
                                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="col-6"></div>
                            <div class="col-6" v-if="!isLoading">
                                <button @click="register()" class="ml-md-5 btn-custom mt-4 float-right w-50">Enviar Acceso</button>
                            </div>
                            <div class="col-12 text-center">
                                <label class="validation" v-show="serverError">{{serverError}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <p class="modal-footer-text" @click="showLogin = !showLogin" v-if="showLogin">Si aún no esta registrado <span class="modal-anchor-text">haz click aquí</span></p>
                        <p class="modal-footer-text" @click="showLogin = !showLogin" v-else>Si ya estas registrado <span class="modal-anchor-text">haz click aquí</span></p>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</div>
